const map = {
	"./ai-chatbot-yoki-jonli-operator.js": 8658,
	"./ai-ni-kichik-biznesga-joriy-etish.js": 8287,
	"./ariza-tannarxi-seo-ads-instagram.js": 7016,
	"./biznes-avtomatlashtirish-yol-xaritasi.js": 4589,
	"./biznesni-raqamlashtirish-talablari-2026.js": 2239,
	"./computer-vision-ombor-va-dokonda.js": 8002,
	"./excel-dan-erp-ga-otish-signallari.js": 5954,
	"./google-business-profil-yaqin-atrofda.js": 9011,
	"./internet-dokon-qonuniy-talablar-2026.js": 6489,
	"./internetdokon.js": 8539,
	"./it-park-rezidentligi-2026.js": 8313,
	"./marketpleys-va-sayt-sinxronizatsiya.js": 8468,
	"./marketpleys-yoki-oz-internet-dokon.js": 6071,
	"./markirovka-kodi-chekda-2026.js": 1092,
	"./onlayn-tolov-ulash-payme-click.js": 5803,
	"./oz-dasturchisi-yoki-autsorsing.js": 919,
	"./ozbekistonda-ikki-tilli-seo.js": 9044,
	"./shaxsiy-malumotlar-qonuni-sayt.js": 1966,
	"./tayyor-crm-yoki-oz-crm-tco.js": 8707,
	"./telegram-bot-nimani-avtomatlashtiradi.js": 3131,
	"./turlari.js": 8590,
	"./ulgurji-savdo-naqdsiz-hisob-kitob.js": 602,
	"./web-sayt.js": 1195
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9686;